import { Card, Col, Row } from "antd";
import React from "react";

import "./Summary.css";

function Summary({data, property }) {
  return (
    <Card title="Summary">
      <Row gutter={[0, 16]} className="summary">
        <Col span={24}>
          <p>
            <span className="onclick-text">{property?.propertyName}</span> |{" "}
            {property?.propertyAddressOne}, {property?.city}, {property?.state}{" "}
            {property?.zipCode}
          </p>
        </Col>
        <Col span={24}>
          <Row>
            <Col span={6} className="col-container">
              <Row gutter={[0, 4]} className="info-container">
                <Col span={24}>
                  <strong className="onclick-text" style={{ fontSize: "18px" }}>
                    ${data?.leaseDetails?.tenantPaymentSchedule?.dueMonthlyThereafter}
                  </strong>
                </Col>
                <Col span={24}>
                  <span className="silver-text">MONTHLY CHARGES</span>
                </Col>
              </Row>
            </Col>
            <Col span={6} className="col-container">
              <Row gutter={[0, 4]} className="info-container">
                <Col span={24}>
                  <strong className="onclick-text" style={{ fontSize: "18px" }}>
                    --
                  </strong>
                </Col>
                <Col span={24}>
                  <span className="silver-text">CURRENT BALANCE</span>
                </Col>
              </Row>
            </Col>
            <Col span={6} className="col-container">
              <Row gutter={[0, 4]} className="info-container">
                <Col span={24}>
                  <strong className="onclick-text" style={{ fontSize: "18px" }}>
                    --
                  </strong>
                </Col>
                <Col span={24}>
                  <span className="silver-text">LAST RECEIPT</span>
                </Col>
              </Row>
            </Col>
            <Col span={6} className="col-container">
              <Row gutter={[0, 4]} className="info-container">
                <Col span={24}>
                  <strong className="onclick-text" style={{ fontSize: "18px" }}>
                    --
                  </strong>
                </Col>
                <Col span={24}>
                  <span className="silver-text">MOVE OUT DATE</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
}

export default Summary;
